module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Please confirm details","periodStart":"Payout date (start date)"},"et":{"title":"Please confirm details","periodStart":"Payout date (start date)"},"ru":{"title":"Please confirm details","periodStart":"Payout date (start date)"}}')
  delete Component.options._Ctor
}
